module.exports = __webpack_public_path__ + "static/media/helpcard_wash.7864ff60.svg";